export const CLEAN_FORM = 'clientes/cargamasivaclientes/clean-form';
export const ADVANCED_SEARCH_CLOSE = 'main/advanced-search-close';
export const ADVANCED_SEARCH_OPEN = 'main/advanced-search-open';
export const SET_STATE_FORM = 'clientes/cargamasivaclientes/set-state-form';
export const UPDATE_FIELD_FILTER = 'clientes/cargamasivaclientes/update-field-filter';
export const RECEIVE_V_LIST = 'clientes/cargamasivaclientes/receive-v-list';
export const REQUEST_V_LIST = 'clientes/cargamasivaclientes/request-v-list';
export const ERROR_V_LIST = 'clientes/cargamasivaclientes/error-v-list';
export const SET_MASK = 'clientes/cargamasivaclientes/set-mask';
export const SET_ORDER = 'clientes/cargamasivaclientes/set-order';
export const RECEIVE_DATA= 'clientes/cargamasivaclientes/receibe-data';
export const UPDATE_TABLE_COLUMN= 'clientes/cargamasivaclientes/update-table-column';
export const SET_PAGE = 'clientes/cargamasivaclientes/set-page';
export const SET_SELECTED_ROW = 'clientes/cargamasivaclientes/set-selected-row';